// Phase 7 R5 — Light vendor normalization for display/filter/grouping ONLY.
// Stored `vendor_name` values are NEVER rewritten by this utility.
//
// `vendorKey` collapses casing/whitespace differences for grouping & search.
// `vendorDisplayLabel` returns a clean trimmed label, falling back to "—".

export const vendorKey = (n: string | null | undefined): string =>
  (n ?? '').trim().toLowerCase();

export const vendorDisplayLabel = (raw: string | null | undefined): string =>
  (raw ?? '').trim() || '—';

/**
 * Pick the most-frequent original casing across a set of vendor names that
 * share the same `vendorKey`. Used so a group of `napa`/`NAPA`/`Napa` rows
 * surfaces a single, readable label without mutating any underlying row.
 */
export function pickCanonicalVendorLabel(rawNames: Array<string | null | undefined>): string {
  const counts = new Map<string, number>();
  for (const n of rawNames) {
    const trimmed = (n ?? '').trim();
    if (!trimmed) continue;
    counts.set(trimmed, (counts.get(trimmed) ?? 0) + 1);
  }
  if (counts.size === 0) return '—';
  let best = '';
  let bestCount = -1;
  for (const [label, count] of counts) {
    if (count > bestCount) {
      best = label;
      bestCount = count;
    }
  }
  return best || '—';
}
